import React from 'react';
import {useHistory} from 'react-router-dom';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

import ImageLogo from '../assets/images/logos/flamingo/lockup/dark.svg';

import styles from '../css/MenuDrawer.module.css';
import baseStyles from '../../css/Base.module.css';
import {BluePillButton} from '../../common/components/BluePillButton';

export default function MenuDrawer({isMenuOpen, toggleMenu}) {
  const history = useHistory();

  return (
    <Drawer anchor="right" open={isMenuOpen} onClose={() => toggleMenu(false)}>
      <ListItem>
        <BluePillButton fullWidth variant="outlined" onClick={() => history.push('/login')}>
          SIGN IN
        </BluePillButton>
      </ListItem>
      <Divider />

      <img src={ImageLogo} className={[styles['menu-logo'], 'm-tb-10'].join(' ')} alt="" />

      <div className={[styles['menu-list'], 'p-10'].join(' ')}>
        <Typography variant="h6" className={baseStyles['text-align-center']}>
          Register your account
        </Typography>
        <Button
          fullWidth
          variant="outlined"
          className={[baseStyles['btn-pill']].join(' ')}
          onClick={() => {
            history.push('/register');
          }}
        >
          CREATE YOUR ACCOUNT
        </Button>
      </div>
    </Drawer>
  );
}
